import App from 'app/app.js';

function EmailValidationService($http, MessageStore) {
  this.validateEmail = function (email) {
    return $http
      .post('emailValidation/validateEmail', {
        email: email
      })
      .then(
        function (response) {
          return response.data;
        }.bind(this),
        function (error) {
          MessageStore.createSystem('COMMON_TEXT_ERROR');
          return false;
        }
      );
  };
}

App.service('EmailValidationService', ['$http', 'MessageStore', EmailValidationService]);
